import { LanguageEnum, SUPPORTED_LANGUAGES } from '@distribusion/portal-lib/constants';

export const LANGUAGE_NAMES: { [key in LanguageEnum]?: string } = {
  [LanguageEnum.EN]: 'English (UK)',
  [LanguageEnum.EN_US]: 'English (US)',
  [LanguageEnum.ES]: 'Español',
  [LanguageEnum.FR]: 'Français',
  [LanguageEnum.PT]: 'Português',
  [LanguageEnum.PT_BR]: 'Português (Brazil)',
  [LanguageEnum.JA]: '日本語',
  [LanguageEnum.UK]: 'Українська',
  [LanguageEnum.VI]: 'Tiếng Việt',
  [LanguageEnum.ZH]: '中文',
  [LanguageEnum.BG]: 'Български',
  [LanguageEnum.HR]: 'Hrvatski',
  [LanguageEnum.CS]: 'Čeština',
  [LanguageEnum.DA]: 'Dansk',
  [LanguageEnum.NL]: 'Nederlands',
  [LanguageEnum.DE]: 'Deutsch',
  [LanguageEnum.HU]: 'Magyar',
  [LanguageEnum.ID]: 'Bahasa Indonesia',
  [LanguageEnum.IT]: 'Italiano',
  [LanguageEnum.PL]: 'Polski',
  [LanguageEnum.RO]: 'Română',
  [LanguageEnum.RU]: 'Русский',
  [LanguageEnum.SV]: 'Svenska',
  [LanguageEnum.TH]: 'ไทย',
  [LanguageEnum.TR]: 'Türkçe',
};

export const LANGUAGE_OPTIONS: Partial<typeof SUPPORTED_LANGUAGES> = [
  LanguageEnum.EN,
  LanguageEnum.EN_US,
  LanguageEnum.ES,
  LanguageEnum.FR,
  LanguageEnum.PT,
  LanguageEnum.PT_BR,
  LanguageEnum.JA,
  LanguageEnum.UK,
  LanguageEnum.VI,
  LanguageEnum.ZH,
  LanguageEnum.BG,
  LanguageEnum.HR,
  LanguageEnum.CS,
  LanguageEnum.DA,
  LanguageEnum.NL,
  LanguageEnum.DE,
  LanguageEnum.HU,
  LanguageEnum.ID,
  LanguageEnum.IT,
  LanguageEnum.PL,
  LanguageEnum.RU,
  LanguageEnum.TH,
  LanguageEnum.RO,
  LanguageEnum.SV,
  LanguageEnum.TR,
];

export const COUNTRY_CODES: { [key in LanguageEnum]?: string } = {
  [LanguageEnum.EN]: 'gb',
  [LanguageEnum.EN_US]: 'us',
  [LanguageEnum.ES]: 'es',
  [LanguageEnum.FR]: 'fr',
  [LanguageEnum.PT]: 'pt',
  [LanguageEnum.PT_BR]: 'br',
  [LanguageEnum.JA]: 'jp',
  [LanguageEnum.UK]: 'ua',
  [LanguageEnum.VI]: 'vn',
  [LanguageEnum.ZH]: 'cn',
  [LanguageEnum.BG]: 'bg',
  [LanguageEnum.HR]: 'hr',
  [LanguageEnum.CS]: 'cz',
  [LanguageEnum.DA]: 'dk',
  [LanguageEnum.NL]: 'nl',
  [LanguageEnum.DE]: 'de',
  [LanguageEnum.HU]: 'hu',
  [LanguageEnum.ID]: 'id',
  [LanguageEnum.IT]: 'it',
  [LanguageEnum.PL]: 'pl',
  [LanguageEnum.RO]: 'ro',
  [LanguageEnum.RU]: 'ru',
  [LanguageEnum.SV]: 'se',
  [LanguageEnum.TH]: 'th',
  [LanguageEnum.TR]: 'tr',
};

export enum ProfileMenuItemsEnum {
  PROFILE = 'profile',
  LOGOUT = 'logout',
  DEMO_MODE = 'demo_mode',
}

export enum UserStateEnum {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export enum AccessTypeEnum {
  INTERNAL = 'internal',
  EXTERNAL = 'external',
}

export enum SortingOptionsEnum {
  DEFAULT = 'default',
}

export const DISTRIBUSION_DOMAIN = '@distribusion.com';
export const DISTRIBUSION_PARTNER_CODE = 'DIST'; // Stub string
